import React from 'react'

interface ActivationCardProps {
    checked: boolean | undefined
    onChange: (value: boolean) => void
}

const ActivationCard: React.FC<ActivationCardProps> = ({ checked, onChange }) => {
    return (
        <div className="card mb-3" style={{ width: "fit-content" }}>
            <div className="card-body p-3">
                <div className="form-check">
                    <label className="form-check-label">
                        <input
                            className="form-check-input"
                            type="checkbox"
                            checked={checked === true}
                            onChange={(e) => onChange(e.currentTarget.checked)}
                        />
                        Activer les plafonds de remise
                    </label>
                </div>
            </div>
        </div>
    )
}

export default ActivationCard
